(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('category-slider')) return;

    // Arrows scroll one screen of tiles; they are shown only when the row overflows
    // and disabled at each end. Swipe and keyboard (Tab through the links) work natively.
    class CategorySlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.arrows = this.querySelector('[data-slider-arrows]');
        this.prev = this.querySelector('[data-slider-prev]');
        this.next = this.querySelector('[data-slider-next]');
        if (!this.track || !this.prev || !this.next) return;
        this.update = this.update.bind(this);
        this.prev.addEventListener('click', () => this.go(-1));
        this.next.addEventListener('click', () => this.go(1));
        this.track.addEventListener('scroll', () => window.requestAnimationFrame(this.update), { passive: true });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.track);
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      go(direction) {
        this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9 });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.arrows.hidden = max <= 2;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    }

    customElements.define('category-slider', CategorySlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
